import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "panel-token",
  disabled: true
}
const _hoisted_2 = { class: "flex flex-wrap align-items-center justify-content-between sm:flex-nowrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-2rem -ml-s2" }, null, -1)
const _hoisted_4 = { class: "flex-center sm:justify-content-start" }
const _hoisted_5 = {
  key: 0,
  class: "caption ml-s2"
}
const _hoisted_6 = {
  key: 0,
  class: "token-notice mt-s1 text-muted"
}
const _hoisted_7 = { class: "w-2rem sm:flex-order-5 flex" }
const _hoisted_8 = { class: "flex sm:ml-auto gutter-y-s1 flex-column sm:align-items-end sm:pl-s2" }
const _hoisted_9 = { class: "token-amount" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap caption align-items-center gutter-x-s1 justify-content-end white-space-nowrap sm:flex-nowrap"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "flex caption align-items-center gutter-x-s1 white-space-nowrap sm:flex-nowrap"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "0", -1)
const _hoisted_14 = {
  key: 1,
  class: "w-full token-notice mt-s2"
}

import { TokenInfo } from '@/sdk/entities/portfolio';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { formatNumbersMixin } from '@/mixins/format-numbers.mixin';
import Notice from '@/components/Notice.vue';
import { computed } from 'vue';
import { useTokenBalance } from '@/composables/token/useTokenBalance';
import { useEasyModeForm } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenUnavailable',
  props: {
    tokenInfo: null,
    action: null,
    noticeType: null
  },
  setup(__props: any) {

const props = __props as {
  tokenInfo: TokenInfo;
  action: string;
  noticeType: string;
}


const { t } = useI18n();
const { state } = useStore();
const { calculateHowManyTokensCanBridgeFromCardano } = useEasyModeForm();
const { format } = formatNumbersMixin.methods;

const noticeText = computed(() =>
  t(`portfolio.easyModeTranslations.${props.action}.tokenNotices.${props.noticeType}.text`),
);
const balance = useTokenBalance(
  computed(() => props.tokenInfo.token),
  {
    subTxFeeFromNativeBalance: true,
    countHowManyCanBridgeFromCardano: calculateHowManyTokensCanBridgeFromCardano(),
  },
);

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TokenIcon, {
              "icon-src": __props.tokenInfo.token.tokenIconUrl,
              symbol: __props.tokenInfo.token.unwrapWETH().symbol,
              full: "",
              class: "icon-muted"
            }, null, 8, ["icon-src", "symbol"]),
            (!_unref(state).layout.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('price')) + ": $" + _toDisplayString(_unref(format)(__props.tokenInfo.price)), 1))
              : _createCommentVNode("", true)
          ]),
          (!_unref(state).layout.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(Notice, {
                  icon: "infoOutlined",
                  text: _unref(noticeText)
                }, null, 8, ["text"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Checkbox, {
            class: "ml-auto",
            disabled: ""
          })
        ]),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createBlock(_component_Divider, {
              key: 0,
              class: "divider-nm"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, "0 " + _toDisplayString(__props.tokenInfo.token.unwrapWETH().symbol), 1),
          (__props.action === 'addLiquidity')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('balance')) + ":", 1),
                (!_unref(balance))
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      class: "w-7rem"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(format)(_unref(balance))) + " " + _toDisplayString(__props.tokenInfo.token.unwrapWETH().symbol), 1))
              ]))
            : _createCommentVNode("", true),
          (__props.action === 'withdraw')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('portfolio.withdraw.noLossLimit')) + ":", 1),
                _hoisted_13
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(Notice, {
                icon: "infoOutlined",
                text: _unref(noticeText)
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})